module.exports = __webpack_public_path__ + "static/media/13ITC3.32681015.jpg";